import { DocumentChecklists } from '../../../cimsPage/instances/concrete'
import { CreateViewEditRemove } from '../../common'

const documentChecklists = CreateViewEditRemove({
  page: DocumentChecklists,
  object: 'Document Checklist Item',
  create: 'E9E4C2E7-FA68-4DFE-A465-1CD01EBA3DDE',
  view: 'B9872CD2-EAEE-48FC-A822-51703462ADD8',
  edit: '3C499AA0-2150-4D51-ADDC-96705FF3F8BC',
  remove: '5C63E80C-0284-4AA4-870C-43F88F551A4F',
})

export const CreateDocumentChecklistItem = documentChecklists.Create
export const ViewDocumentChecklistItem = documentChecklists.View
export const EditDocumentChecklistItem = documentChecklists.Edit
export const RemoveDocumentChecklistItem = documentChecklists.Remove

export type DocumentChecklistPermission =
  | typeof CreateDocumentChecklistItem
  | typeof ViewDocumentChecklistItem
  | typeof EditDocumentChecklistItem
  | typeof RemoveDocumentChecklistItem
